import { PricingCard } from './PricingCard';
import type { Plan } from '../../../types/subscription';

interface SubscriptionCardsProps {
  plans: Plan[];
  onCheckout: (priceId: string, cancelUrl: string, name: string) => void;
  subPriceId?: string;
  subsPlanName?: string;
  isAuthenticated: boolean;
  link?: string;
  freeSubsName: string;
  isLoading: boolean;
}

export function SubscriptionCards({
  plans,
  onCheckout,
  subPriceId,
  subsPlanName,
  isAuthenticated,
  link,
  freeSubsName,
  isLoading,
}: SubscriptionCardsProps) {
  return (
    <>
      {plans
        .filter((plan) => plan.price)
        .map((plan) => (
          <PricingCard
            key={plan.name}
            {...plan}
            onCheckout={onCheckout}
            subPriceId={subPriceId}
            subsPlanName={subsPlanName}
            isAuthenticated={isAuthenticated}
            link={link}
            freeSubsName={freeSubsName}
            isLoading={isLoading}
          />
        ))}
    </>
  );
}

